var newURL = location.href.split("?")[0];
window.history.pushState('object', document.title, newURL);

//udesly code
//history.replaceState(null, '', window.location.href.split('?')[0]);
//history.replaceState = console.log; 

$( document ).ready(function() {

});